import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IProjectFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  name: string
  code: string
  logoUrl?: string | null
  isLogoWhite?: boolean | null
  headerImageUrl?: string | null
  scheduleId?: any | null
  materialsUploadId?: any | null
  dateTimeFormat?: string | null
  defaultLandingPage?: Types.DefaultLandingPage | null
  timezoneId?: string | null
  setUpFinished?: Array<string | null> | null
  workingDays?: Array<number | null> | null
  areWorkflowMarkupsDisabledByDefault?: boolean | null
  closedIntervals?: Array<{
    name?: string | null
    startDate: any
    endDate: any
  } | null> | null
  workingHours?: { startTime: any; endTime: any } | null
  workingSchedule?: Array<{
    dayOfWeek: number
    startTime?: any | null
    endTime?: any | null
  } | null> | null
}

export type IGetAvailableProjectsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type IGetAvailableProjectsQuery = {
  getAvailableProjects?: Array<{
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    name: string
    code: string
    logoUrl?: string | null
    isLogoWhite?: boolean | null
    headerImageUrl?: string | null
    scheduleId?: any | null
    materialsUploadId?: any | null
    dateTimeFormat?: string | null
    defaultLandingPage?: Types.DefaultLandingPage | null
    timezoneId?: string | null
    setUpFinished?: Array<string | null> | null
    workingDays?: Array<number | null> | null
    areWorkflowMarkupsDisabledByDefault?: boolean | null
    closedIntervals?: Array<{
      name?: string | null
      startDate: any
      endDate: any
    } | null> | null
    workingHours?: { startTime: any; endTime: any } | null
    workingSchedule?: Array<{
      dayOfWeek: number
      startTime?: any | null
      endTime?: any | null
    } | null> | null
  } | null> | null
}

export type ICheckIsProjectCodeUniqueQueryVariables = Types.Exact<{
  projectCode: Types.Scalars['String']['input']
}>

export type ICheckIsProjectCodeUniqueQuery = {
  checkIsProjectCodeUnique?: boolean | null
}

export type ISaveProjectsMutationVariables = Types.Exact<{
  projects:
    | Array<Types.InputMaybe<Types.IProjectInput>>
    | Types.InputMaybe<Types.IProjectInput>
}>

export type ISaveProjectsMutation = {
  saveManyProjects?: Array<{
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    name: string
    code: string
    logoUrl?: string | null
    isLogoWhite?: boolean | null
    headerImageUrl?: string | null
    scheduleId?: any | null
    materialsUploadId?: any | null
    dateTimeFormat?: string | null
    defaultLandingPage?: Types.DefaultLandingPage | null
    timezoneId?: string | null
    setUpFinished?: Array<string | null> | null
    workingDays?: Array<number | null> | null
    areWorkflowMarkupsDisabledByDefault?: boolean | null
    closedIntervals?: Array<{
      name?: string | null
      startDate: any
      endDate: any
    } | null> | null
    workingHours?: { startTime: any; endTime: any } | null
    workingSchedule?: Array<{
      dayOfWeek: number
      startTime?: any | null
      endTime?: any | null
    } | null> | null
  } | null> | null
}

export type ISaveProjectsDataMutationVariables = Types.Exact<{
  projectsData:
    | Array<Types.InputMaybe<Types.IProjectDataInput>>
    | Types.InputMaybe<Types.IProjectDataInput>
}>

export type ISaveProjectsDataMutation = {
  saveManyProjectsData?: Array<{
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    name: string
    code: string
    logoUrl?: string | null
    isLogoWhite?: boolean | null
    headerImageUrl?: string | null
    scheduleId?: any | null
    materialsUploadId?: any | null
    dateTimeFormat?: string | null
    defaultLandingPage?: Types.DefaultLandingPage | null
    timezoneId?: string | null
    setUpFinished?: Array<string | null> | null
    workingDays?: Array<number | null> | null
    areWorkflowMarkupsDisabledByDefault?: boolean | null
    closedIntervals?: Array<{
      name?: string | null
      startDate: any
      endDate: any
    } | null> | null
    workingHours?: { startTime: any; endTime: any } | null
    workingSchedule?: Array<{
      dayOfWeek: number
      startTime?: any | null
      endTime?: any | null
    } | null> | null
  } | null> | null
}

export type IUpdateProjectIsLogoWhiteMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  isLogoWhite: Types.Scalars['Boolean']['input']
}>

export type IUpdateProjectIsLogoWhiteMutation = {
  updateProjectIsLogoWhite?: {
    id?: any | null
    name: string
    code: string
    logoUrl?: string | null
    isLogoWhite?: boolean | null
  } | null
}

export type IListenToProjectSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IListenToProjectSubscription = {
  project?: {
    id?: any | null
    item?: {
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      name: string
      code: string
      logoUrl?: string | null
      isLogoWhite?: boolean | null
      headerImageUrl?: string | null
      scheduleId?: any | null
      materialsUploadId?: any | null
      dateTimeFormat?: string | null
      defaultLandingPage?: Types.DefaultLandingPage | null
      timezoneId?: string | null
      setUpFinished?: Array<string | null> | null
      workingDays?: Array<number | null> | null
      areWorkflowMarkupsDisabledByDefault?: boolean | null
      closedIntervals?: Array<{
        name?: string | null
        startDate: any
        endDate: any
      } | null> | null
      workingHours?: { startTime: any; endTime: any } | null
      workingSchedule?: Array<{
        dayOfWeek: number
        startTime?: any | null
        endTime?: any | null
      } | null> | null
    } | null
  } | null
}

export const ProjectFieldsFragmentDoc = gql`
  fragment ProjectFields on Project {
    id
    createdAt
    updatedAt
    name
    code
    logoUrl
    isLogoWhite
    headerImageUrl
    scheduleId
    materialsUploadId
    dateTimeFormat
    defaultLandingPage
    timezoneId
    closedIntervals {
      name
      startDate
      endDate
    }
    setUpFinished
    workingDays
    workingHours {
      startTime
      endTime
    }
    workingSchedule {
      dayOfWeek
      startTime
      endTime
    }
    areWorkflowMarkupsDisabledByDefault
  }
`
export const GetAvailableProjectsDocument = gql`
  query GetAvailableProjects {
    getAvailableProjects {
      ...ProjectFields
    }
  }
  ${ProjectFieldsFragmentDoc}
`

/**
 * __useGetAvailableProjectsQuery__
 *
 * To run a query within a React component, call `useGetAvailableProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IGetAvailableProjectsQuery,
    IGetAvailableProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetAvailableProjectsQuery,
    IGetAvailableProjectsQueryVariables
  >(GetAvailableProjectsDocument, options)
}
export function useGetAvailableProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetAvailableProjectsQuery,
    IGetAvailableProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetAvailableProjectsQuery,
    IGetAvailableProjectsQueryVariables
  >(GetAvailableProjectsDocument, options)
}
export type GetAvailableProjectsQueryHookResult = ReturnType<
  typeof useGetAvailableProjectsQuery
>
export type GetAvailableProjectsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableProjectsLazyQuery
>
export type GetAvailableProjectsQueryResult = Apollo.QueryResult<
  IGetAvailableProjectsQuery,
  IGetAvailableProjectsQueryVariables
>
export const CheckIsProjectCodeUniqueDocument = gql`
  query CheckIsProjectCodeUnique($projectCode: String!) {
    checkIsProjectCodeUnique(projectCode: $projectCode)
  }
`

/**
 * __useCheckIsProjectCodeUniqueQuery__
 *
 * To run a query within a React component, call `useCheckIsProjectCodeUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIsProjectCodeUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIsProjectCodeUniqueQuery({
 *   variables: {
 *      projectCode: // value for 'projectCode'
 *   },
 * });
 */
export function useCheckIsProjectCodeUniqueQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICheckIsProjectCodeUniqueQuery,
    ICheckIsProjectCodeUniqueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ICheckIsProjectCodeUniqueQuery,
    ICheckIsProjectCodeUniqueQueryVariables
  >(CheckIsProjectCodeUniqueDocument, options)
}
export function useCheckIsProjectCodeUniqueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICheckIsProjectCodeUniqueQuery,
    ICheckIsProjectCodeUniqueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICheckIsProjectCodeUniqueQuery,
    ICheckIsProjectCodeUniqueQueryVariables
  >(CheckIsProjectCodeUniqueDocument, options)
}
export type CheckIsProjectCodeUniqueQueryHookResult = ReturnType<
  typeof useCheckIsProjectCodeUniqueQuery
>
export type CheckIsProjectCodeUniqueLazyQueryHookResult = ReturnType<
  typeof useCheckIsProjectCodeUniqueLazyQuery
>
export type CheckIsProjectCodeUniqueQueryResult = Apollo.QueryResult<
  ICheckIsProjectCodeUniqueQuery,
  ICheckIsProjectCodeUniqueQueryVariables
>
export const SaveProjectsDocument = gql`
  mutation SaveProjects($projects: [ProjectInput]!) {
    saveManyProjects(projects: $projects) {
      ...ProjectFields
    }
  }
  ${ProjectFieldsFragmentDoc}
`
export type ISaveProjectsMutationFn = Apollo.MutationFunction<
  ISaveProjectsMutation,
  ISaveProjectsMutationVariables
>

/**
 * __useSaveProjectsMutation__
 *
 * To run a mutation, you first call `useSaveProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectsMutation, { data, loading, error }] = useSaveProjectsMutation({
 *   variables: {
 *      projects: // value for 'projects'
 *   },
 * });
 */
export function useSaveProjectsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveProjectsMutation,
    ISaveProjectsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveProjectsMutation,
    ISaveProjectsMutationVariables
  >(SaveProjectsDocument, options)
}
export type SaveProjectsMutationHookResult = ReturnType<
  typeof useSaveProjectsMutation
>
export type SaveProjectsMutationResult =
  Apollo.MutationResult<ISaveProjectsMutation>
export type SaveProjectsMutationOptions = Apollo.BaseMutationOptions<
  ISaveProjectsMutation,
  ISaveProjectsMutationVariables
>
export const SaveProjectsDataDocument = gql`
  mutation SaveProjectsData($projectsData: [ProjectDataInput]!) {
    saveManyProjectsData(projectsData: $projectsData) {
      ...ProjectFields
    }
  }
  ${ProjectFieldsFragmentDoc}
`
export type ISaveProjectsDataMutationFn = Apollo.MutationFunction<
  ISaveProjectsDataMutation,
  ISaveProjectsDataMutationVariables
>

/**
 * __useSaveProjectsDataMutation__
 *
 * To run a mutation, you first call `useSaveProjectsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectsDataMutation, { data, loading, error }] = useSaveProjectsDataMutation({
 *   variables: {
 *      projectsData: // value for 'projectsData'
 *   },
 * });
 */
export function useSaveProjectsDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveProjectsDataMutation,
    ISaveProjectsDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveProjectsDataMutation,
    ISaveProjectsDataMutationVariables
  >(SaveProjectsDataDocument, options)
}
export type SaveProjectsDataMutationHookResult = ReturnType<
  typeof useSaveProjectsDataMutation
>
export type SaveProjectsDataMutationResult =
  Apollo.MutationResult<ISaveProjectsDataMutation>
export type SaveProjectsDataMutationOptions = Apollo.BaseMutationOptions<
  ISaveProjectsDataMutation,
  ISaveProjectsDataMutationVariables
>
export const UpdateProjectIsLogoWhiteDocument = gql`
  mutation UpdateProjectIsLogoWhite(
    $projectId: ObjectId!
    $isLogoWhite: Boolean!
  ) {
    updateProjectIsLogoWhite(projectId: $projectId, isLogoWhite: $isLogoWhite) {
      id
      name
      code
      logoUrl
      isLogoWhite
    }
  }
`
export type IUpdateProjectIsLogoWhiteMutationFn = Apollo.MutationFunction<
  IUpdateProjectIsLogoWhiteMutation,
  IUpdateProjectIsLogoWhiteMutationVariables
>

/**
 * __useUpdateProjectIsLogoWhiteMutation__
 *
 * To run a mutation, you first call `useUpdateProjectIsLogoWhiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectIsLogoWhiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectIsLogoWhiteMutation, { data, loading, error }] = useUpdateProjectIsLogoWhiteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      isLogoWhite: // value for 'isLogoWhite'
 *   },
 * });
 */
export function useUpdateProjectIsLogoWhiteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectIsLogoWhiteMutation,
    IUpdateProjectIsLogoWhiteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectIsLogoWhiteMutation,
    IUpdateProjectIsLogoWhiteMutationVariables
  >(UpdateProjectIsLogoWhiteDocument, options)
}
export type UpdateProjectIsLogoWhiteMutationHookResult = ReturnType<
  typeof useUpdateProjectIsLogoWhiteMutation
>
export type UpdateProjectIsLogoWhiteMutationResult =
  Apollo.MutationResult<IUpdateProjectIsLogoWhiteMutation>
export type UpdateProjectIsLogoWhiteMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectIsLogoWhiteMutation,
    IUpdateProjectIsLogoWhiteMutationVariables
  >
export const ListenToProjectDocument = gql`
  subscription ListenToProject($id: ObjectId!) {
    project(id: $id) {
      id
      item {
        ...ProjectFields
      }
    }
  }
  ${ProjectFieldsFragmentDoc}
`

/**
 * __useListenToProjectSubscription__
 *
 * To run a query within a React component, call `useListenToProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToProjectSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListenToProjectSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToProjectSubscription,
    IListenToProjectSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToProjectSubscription,
    IListenToProjectSubscriptionVariables
  >(ListenToProjectDocument, options)
}
export type ListenToProjectSubscriptionHookResult = ReturnType<
  typeof useListenToProjectSubscription
>
export type ListenToProjectSubscriptionResult =
  Apollo.SubscriptionResult<IListenToProjectSubscription>
